<h2 class="heading-1">{{ vm.title }}</h2>

<div class="feedback-container">
  <p class="body intro-copy">
    We're always working to improve Smart-fix. So we'd appreciate you taking a minute to tell us how we did.
  </p>

  <div class="rating-form">
    <div class="star-rating" data-testid="star-rating">
      <p class="body bold mb-2">How would you rate your experience?</p>
      <div class="star-container">
        @for (star of ratingScale; track star) {
          <div
            class="star"
            [innerHTML]="starSvg"
            tabindex="0"
            (click)="setRating(+star)"
            (keydown.enter)="setRating(+star)"
            [class.star-selected]="rating >= star"
          ></div>
        }
      </div>
      @if (showPositiveMessage) {
        <div class="thank-you-message">
          🎉
          <p class="body bold">Excellent! Thank you.</p>
        </div>
      }
    </div>
  </div>

  @for (question of shownQuestions(); track question.id) {
    <div class="progress-feedback-section" #questionSection>
      <p class="body bold">{{ question.text }}</p>
      @if (question.type === 'radio') {
        <section class="feedback-radios">
          @for (answer of question.answers; track answer.id; let index = $index) {
            <app-radio-button
              variant="blue"
              [optionValue]="answer.id"
              [index]="index"
              [name]="question.id"
              [ngModel]="selectedAnswers()[question.id]"
              (ngModelChange)="selectAnswer(question, answer, $event)"
              [includeResetOption]="true"
              [showResetIcon]="false"
            >
              <p>{{ answer.text }}</p>
            </app-radio-button>
          }
        </section>
      }
    </div>
  }
</div>

<section class="actions flex-col gap-12">
  <app-button
    dataLabel="submit-feedback"
    class="min-w-160"
    [buttonOptions]="{ disabled: isSubmitDisabled }"
    (onClick)="submitFeedback()"
  >
    @if (isSubmitting) {
      <app-loading-spinner variant="white" [size]="20"></app-loading-spinner>
      <app-smart-fix-feedback-modal></app-smart-fix-feedback-modal>
    } @else {
      {{ submitButtonLabel }}
    }
  </app-button>
  <section class="back-link">
    <a (click)="goToBookEngineer()" dataLabel="book-engineer" tabindex="0"
      >{{ stepsOutcomeAnswer().problemIsResolved === true ? 'Skip, cancel booking' : 'Skip giving feedback' }}
    </a>
  </section>
</section>
